var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 620,
    viewBox: "0 0 564 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.145 435.184C220.686 526.41 404.726 544.55 488.736 499.168C567.564 456.583 576.752 381.189 530.695 305.587C469.608 205.327 531.641 127.071 466.882 50.2621C423.054 -1.71299 252.456 -29.3083 123.849 48.617C-2.84102 125.379 -65.2442 306.36 102.153 435.185L102.145 435.184Z",
    fill: "#EADEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9552 274.902C60.2225 141.62 168.713 44.5858 256.436 48.0355C338.734 51.2731 398.481 114.31 421.91 201.831C452.976 317.888 549.603 360.276 561.561 457.061C569.652 522.579 476.76 622.116 336.43 609.297C198.205 596.716 28.209 463.128 46.9552 274.902Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1366 320.531C28.8557 184.092 109.348 71.0816 189.388 62.4224C264.477 54.2938 330.026 109.697 367.17 194.825C416.441 307.733 511.618 337.12 540.084 433.235C559.339 498.28 493.413 611.667 364.071 618.16C236.691 624.568 58.4955 513.179 41.1366 320.531Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back2.4a4c4fcd451dcfb63625d379006081ff.svg";
export { ForwardRef as ReactComponent };